import { render, staticRenderFns } from "./addParter.vue?vue&type=template&id=6ed79324&scoped=true"
import script from "./addParter.vue?vue&type=script&lang=js"
export * from "./addParter.vue?vue&type=script&lang=js"
import style0 from "./addParter.vue?vue&type=style&index=0&id=6ed79324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed79324",
  null
  
)

export default component.exports